import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardCheck, HardHat, ShieldCheck } from 'lucide-react';

const steps = [
  { num: '01', icon: ClipboardCheck, title: 'Sopralluogo Gratuito', desc: 'Un tecnico analizza la copertura, identifica le criticita e propone la soluzione ottimale. Nessun impegno, nessun costo.' },
  { num: '02', icon: HardHat, title: 'Intervento Rapido', desc: 'Senza ponteggi, senza demolizioni, senza cantiere invasivo. Tecnici certificati con sistemi di sicurezza avanzati.' },
  { num: '03', icon: ShieldCheck, title: 'Garanzia Certificata', desc: 'Certificazione scritta con garanzia fino a 10 anni. Fine dei problemi, inizio della tranquillita.' },
];

const fasi = [
  { img: '/brochure/fase-rimozione.jpg', label: 'Rimozione elementi danneggiati' },
  { img: '/brochure/fase-posa.jpg', label: 'Posa nuovi coppi/tegole' },
  { img: '/brochure/fase-fissaggio.jpg', label: 'Fissaggio con schiuma certificata' },
  { img: '/brochure/fase-trattamento.jpg', label: 'Trattamento idrorepellente' },
];

const ProcessSection = () => (
  <section id="metodo" className="py-24 md:py-32 bg-slate-50">
    <div className="max-w-7xl mx-auto px-6 md:px-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-16">
        <span className="text-[#FF5722] text-sm font-semibold uppercase tracking-wider">Il nostro metodo</span>
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mt-3">3 passi verso la tranquillita</h2>
      </motion.div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {steps.map((step, i) => (
          <motion.div key={step.num} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.15 }} className="relative">
            <div className="bg-white border border-slate-200 rounded-2xl p-8 h-full hover:border-[#FF5722]/30 hover:shadow-lg transition-all duration-300">
              <span className="text-5xl font-bold text-[#FF5722]/10 absolute top-6 right-6" style={{ fontFamily: 'Outfit' }}>{step.num}</span>
              <div className="w-12 h-12 bg-[#FF5722]/10 rounded-xl flex items-center justify-center mb-5"><step.icon className="w-6 h-6 text-[#FF5722]" /></div>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">{step.title}</h3>
              <p className="text-sm text-slate-500 leading-relaxed">{step.desc}</p>
            </div>
            {i < steps.length - 1 && <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-[2px] bg-[#FF5722]/20" />}
          </motion.div>
        ))}
      </div>

      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mt-20 mb-8">
        <h3 className="text-xl font-bold text-slate-900" style={{ fontFamily: 'Outfit' }}>Il lavoro, fase per fase</h3>
        <p className="text-slate-500 text-sm mt-2">Come interveniamo sul manto di copertura: dalla rimozione al trattamento finale.</p>
      </motion.div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="process-phases">
        {fasi.map((f, i) => (
          <motion.figure key={f.label} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }} className="bg-white rounded-2xl overflow-hidden border border-slate-200 shadow-sm">
            <img src={f.img} alt={f.label} loading="lazy" className="w-full h-40 object-cover hover:scale-105 transition-transform duration-500" />
            <figcaption className="px-3 py-3 text-xs font-semibold text-slate-700 text-center">{f.label}</figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default ProcessSection;
